<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <h4>Mağaza Aylık Fatura Tutarları - Özet Rapor</h4>
        <p style="color: #6c757d">
          {{
            isAdmin
              ? "Mağazaların aylık toplam fatura tutarlarını görüntüleyin"
              : "Mağazanızın aylık toplam fatura tutarlarını görüntüleyin"
          }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" sm="4">
        <v-autocomplete
          :items="allInvoicePeriods"
          item-text="text"
          v-model="invoicePeriods"
          item-value="value"
          label="Dönem Seçimi"
          data-vv-name="select"
          required
          multiple
          chips
          clearable
          searchable
          @change="onInvoicePeriodChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" sm="4" v-if="isAdmin">
        <v-text-field
          class="input_custom"
          v-model="monthlyInvoiceSummaryPageData.CompanyName"
          append-icon="mdi-magnify"
          label="Firma Adı"
          single-line
          hide-details
          maxlength="200"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="12"
        sm="12"
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
        "
      >
        <v-btn
          color="#4d48f9"
          style="text-transform: none !important; color: white"
          @click="searchFilter()"
        >
          <v-icon style="font-size: 17px" color="white"> search </v-icon>
          Ara
        </v-btn>
        <v-btn
          depressed
          @click="clearSearch()"
          style="
            text-transform: none !important;
            float: left;
            color: white;
            background: white;
            color: #6c757d;
            border: 1px solid #dee2e6;
            cursor: pointer;
          "
        >
          <v-icon style="font-size: 17px" color="#6c757d">delete</v-icon>
          Filtreleri Temizle
        </v-btn>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        <p style="color: #6c757d; font-size: 14px; font-weight: 400">
          Toplam
          <strong style="color: black">{{ pagination.totalItems }}</strong>
          Kayıt Bulundu
        </p>
        <v-spacer></v-spacer>
        <div style="display: flex; flex-direction: column; gap: 10px">
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              justify-content: flex-end;
            "
          >
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="exportReports('excel')"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                background: white;
                color: #6c757d;
                border: 1px solid #dee2e6;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-file-excel</v-icon
              >
              Excel İndir
            </v-btn>
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="exportReports('csv')"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                background: white;
                color: #6c757d;
                border: 1px solid #dee2e6;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-file-delimited</v-icon
              >
              CSV İndir
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="isAdmin ? adminHeaders : venueHeaders"
        :items="allStoreMonthlyInvoiceSummary"
        style="white-space: nowrap"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          disablePagination: true,
        }"
        :items-per-page="10"
        @update:page="getPageNumber"
        @update:items-per-page="getItemPerPage"
      >
        <template v-slot:item.invoiceAmount="{ item }">
          <td class="text-start">{{ item.invoiceAmount }} ₺</td>
        </template>
        <template v-slot:item.grossInvoiceAmount="{ item }">
          <td class="text-start">{{ item.grossInvoiceAmount }} ₺</td>
        </template>
        <template v-slot:item.vatRate="{ item }">
          <td class="text-start">%{{ item.vatRate }}</td>
        </template>
        <template v-slot:item.vatAmount="{ item }">
          <td class="text-start">{{ item.vatAmount }} ₺</td>
        </template>
        <template v-slot:item.invoiceFileUrl="{ item }">
          <td v-if="item.invoiceFileUrl" class="text-start">
            <a
              class="pdf-link"
              :href="item.invoiceFileUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-file-eye-outline</v-icon
              >
              Görüntüle
            </a>
          </td>
          <td v-if="!item.invoiceFileUrl" class="text-start">
            <div class="pdf-not-found">
              <v-icon style="font-size: 17px" color="#6c757d"
                >mdi-cancel</v-icon
              >
              Fatura Bulunamadı
            </div>
          </td>
        </template>
        <template v-if="!isAdmin" v-slot:item.fileUpload="{ item, index }">
          <td v-if="!item.invoiceFileUrl" class="text-start">
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="openFilePicker(index)"
              color="success"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="white">mdi-upload</v-icon>
              Yükle</v-btn
            >
            <v-file-input
              :ref="`fileInput_${index}`"
              show-size
              outlined
              dense
              v-model="file"
              label="Dosya yükle"
              @change="(e) => handleUpload(e, item)"
              accept="image/jpg, image/jpeg, image/png, application/pdf"
              prepend-icon="mdi-upload"
              style="display: none"
            >
            </v-file-input>
          </td>
          <td v-if="item.invoiceFileUrl" class="text-start">
            <v-btn
              depressed
              :disabled="loading"
              :loading="loading"
              @click="
                deleteModal = true;
                deleteItem = item;
              "
              color="error"
              style="
                text-transform: none !important;
                float: left;
                color: white;
                cursor: pointer;
              "
            >
              <v-icon style="font-size: 17px" color="white">mdi-delete</v-icon>
              Sil</v-btn
            >
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="monthlyInvoiceSummaryPageData.pageNumber"
          :color="'#4d48f9'"
          :length="pagination.pagesLength"
          @input="setPageNumber"
          :total-visible="10"
        ></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="deleteModal" max-width="600">
      <v-card style="text-align: center">
        <v-card-title
          style="display: flex; justify-content: center"
          class="headline"
        >
          Fatura Silinecek
        </v-card-title>

        <v-card-text>
          <p>Faturayı silmek istediğinizden emin misin?</p>
          <v-row style="gap: 8px; justify-content: flex-end; margin-top: 12px">
            <v-btn
              depressed
              @click="
                deleteModal = false;
                deleteItem = null;
              "
              style="text-transform: none !important"
            >
              İptal
            </v-btn>
            <v-btn
              depressed
              color="error"
              style="text-transform: none !important; color: white"
              @click="deleteInvoice(deleteItem)"
            >
              Sil
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadModal" max-width="600">
      <v-card style="text-align: center">
        <v-card-title
          style="display: flex; justify-content: center"
          class="headline"
        >
          Fatura Yükle
        </v-card-title>

        <v-card-text>
          <p>Faturayı yüklemek istediğinizden emin misiniz?</p>
          <v-row style="gap: 8px; justify-content: flex-end; margin-top: 12px">
            <v-btn
              depressed
              @click="
                uploadModal = false;
                file = null;
                uploadItem = null;
              "
              style="text-transform: none !important"
            >
              İptal
            </v-btn>
            <v-btn
              depressed
              color="success"
              style="text-transform: none !important; color: white"
              @click="uploadInvoice(uploadItem)"
            >
              Yükle
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MonthlyInvoiceSummary",
  data: () => ({
    monthlyInvoiceSummaryPageData: {
      pageNumber: 1,
      pageSize: 10,
      CompanyName: "",
      invoicePeriods: [],
    },
    file: null,
    CompanyNameData: "",
    invoicePeriods: [],
    deleteModal: false,
    deleteItem: null,
    uploadModal: false,
    uploadItem: null,
    isAdmin: false,
    initialPeriod: "",
    pagination: {
      totalItems: 20,
      pagesLength: 0,
    },
    adminHeaders: [
      {
        text: "Firma adı",
        value: "companyName",
        align: "start",
        sortable: false,
      },
      { text: "Mağaza Adı", value: "venueName", sortable: false },
      { text: "Fatura Dönemi", value: "period", sortable: false },
      { text: "Fatura Tutarı", value: "invoiceAmount", sortable: false },
      { text: "KDV Oranı", value: "vatRate", sortable: false },
      { text: "KDV Tutarı", value: "vatAmount", sortable: false },
      {
        text: "Kesilmesi Gereken Fatura Tutarı",
        value: "grossInvoiceAmount",
        sortable: false,
      },
      { text: "Fatura PDF", value: "invoiceFileUrl", sortable: false },
    ],
    venueHeaders: [
      {
        text: "Firma adı",
        value: "companyName",
        align: "start",
        sortable: false,
      },
      { text: "Mağaza Adı", value: "venueName", sortable: false },
      { text: "Fatura Dönemi", value: "period", sortable: false },
      { text: "Fatura Tutarı", value: "invoiceAmount", sortable: false },
      { text: "KDV Oranı", value: "vatRate", sortable: false },
      { text: "KDV Tutarı", value: "vatAmount", sortable: false },
      {
        text: "Kesilmesi Gereken Fatura Tutarı",
        value: "grossInvoiceAmount",
        sortable: false,
      },
      { text: "Fatura Yükle", value: "fileUpload", sortable: false },
      { text: "Fatura PDF", value: "invoiceFileUrl", sortable: false },
    ],
  }),
  watch: {
    "$route.query.page"(val) {
      const pageNumber = val ? Number(val) : 1;
      this.getPageNumber(pageNumber);
    },
  },
  computed: mapGetters([
    "allStoreMonthlyInvoiceSummary",
    "loading",
    "allInvoicePeriods",
  ]),
  created() {
    const page = this.$route.query.page ? this.$route.query.page : 1;
    const initialPeriod = this.getInitialPeriod();
    this.monthlyInvoiceSummaryPageData.pageNumber = Number(page);
    this.monthlyInvoiceSummaryPageData.invoicePeriods = [initialPeriod];
    this.invoicePeriods = [initialPeriod];
    this.initialPeriod = initialPeriod;

    this.userRoles = JSON.parse(localStorage.getItem("userRoles"));
    if (
      this.userRoles.find((x) => x == "PanelUser") != null &&
      this.userRoles.find((x) => x == "PanelUser") != undefined
    ) {
      this.isAdmin = true;
    }

    this.getStoreMonthlyInvoiceSummary(this.monthlyInvoiceSummaryPageData).then(
      (response) => {
        this.pagination.totalItems = response.totalCount;
        this.pagination.pagesLength = response.totalPages;
      },
    );
    this.getInvoicePeriods();
  },
  methods: {
    ...mapActions([
      "getStoreMonthlyInvoiceSummary",
      "getStoreMonthlyInvoiceSummaryReports",
      "getInvoicePeriods",
      "deleteStoreInvoice",
      "uploadStoreInvoice",
    ]),
    //Data table item per page changed function
    getItemPerPage(val) {
      this.monthlyInvoiceSummaryPageData.pageSize = val;
      this.monthlyInvoiceSummaryPageData.pageNumber = 1;
      this.getStoreMonthlyInvoiceSummary(
        this.monthlyInvoiceSummaryPageData,
      ).then((res) => {
        this.pagination.pagesLength = res.totalPages;
      });
    },
    searchFilter() {
      if (this.invoicePeriods.length > 0) {
        this.monthlyInvoiceSummaryPageData.invoicePeriods = this.invoicePeriods;
      } else {
        this.monthlyInvoiceSummaryPageData.invoicePeriods = [
          this.initialPeriod,
        ];
        this.invoicePeriods = [this.initialPeriod];
      }

      this.monthlyInvoiceSummaryPageData.pageNumber = 1;

      this.getStoreMonthlyInvoiceSummary(
        this.monthlyInvoiceSummaryPageData,
      ).then((response) => {
        this.pagination.totalItems = response.totalCount;
        this.pagination.pagesLength = response.totalPages;
      });
    },
    clearSearch() {
      this.monthlyInvoiceSummaryPageData = {
        pageNumber: 1,
        pageSize: 10,
        CompanyName: "",
        invoicePeriods: [],
      };
      this.invoicePeriods = [this.initialPeriod];
      this.searchFilter();
    },
    //Data table page number changed function
    getPageNumber(val) {
      this.monthlyInvoiceSummaryPageData.pageNumber = val;
      if (val !== 1) {
        this.$router.push({ query: { page: val } });
      }
      this.getStoreMonthlyInvoiceSummary(this.monthlyInvoiceSummaryPageData);
    },
    setPageNumber(val) {
      if (
        (!this.$route.query.page && val == 1) ||
        this.$route.query.page == val
      )
        return;
      this.$router.push({ path: this.$route.fullPath, query: { page: val } });
    },
    async exportReports(type, useFilters = true) {
      let result;
      if (useFilters) {
        result = await this.getStoreMonthlyInvoiceSummaryReports({
          pageNumber: this.monthlyInvoiceSummaryPageData.pageNumber,
          pageSize: this.monthlyInvoiceSummaryPageData.pageSize,
          CompanyName: this.monthlyInvoiceSummaryPageData.CompanyName,
          invoicePeriods: this.monthlyInvoiceSummaryPageData.invoicePeriods,
          type: type,
        });
      } else {
        result = await this.getStoreMonthlyInvoiceSummaryReports({
          type: type,
        });
      }

      if (result.status != 200)
        this.$toasted.show(
          result.data.friendlyMessage.message || "Hata Oluştu.",
          {
            duration: 3000,
            position: "top-right",
            type: "error",
          },
        );
      else {
        this.$toasted.show("Rapor İndirme Başarılı", {
          duration: 3000,
          position: "top-right",
          type: "success",
        });
      }
    },
    onInvoicePeriodChange(selectedIds) {
      this.invoicePeriods = selectedIds;
    },
    openFilePicker(index) {
      this.$nextTick(() => {
        this.$refs[`fileInput_${index}`].$el.querySelector("input").click();
      });
    },
    handleUpload(e, item) {
      if (e.size > 5 * 1024 * 1024) {
        this.$toasted.show("Yüklediğiniz dosya 5MB altında olmalıdır.", {
          duration: 3000,
          position: "top-right",
          type: "error",
        });
        return;
      } else {
        this.file = e;
        this.uploadItem = item;
        this.uploadModal = true;
      }
    },
    async uploadInvoice(item) {
      const [month, year] = item.period.toString().split(".");
      const fullYear = Number(year) + 2000;
      const paddedMonth = month.padStart(2, "0");
      const postData = {
        venueId: item.venueId,
        period: `${fullYear}-${paddedMonth}`,
        file: this.file,
      };
      this.uploadModal = false;
      const result = await this.uploadStoreInvoice(postData);
      if (result.status != 200)
        this.$toasted.show(
          result.data.friendlyMessage.message || "Hata Oluştu.",
          {
            duration: 3000,
            position: "top-right",
            type: "error",
          },
        );
      else {
        this.$toasted.show("Fatura Başarıyla Eklendi.", {
          duration: 3000,
          position: "top-right",
          type: "success",
        });
        this.searchFilter();
      }
      this.file = null;
      this.uploadItem = null;
    },
    async deleteInvoice(item) {
      const [month, year] = item.period.toString().split(".");
      const fullYear = Number(year) + 2000;
      const paddedMonth = month.padStart(2, "0");
      const postData = {
        venueId: item.venueId,
        period: `${fullYear}-${paddedMonth}`,
      };
      this.deleteModal = false;
      const result = await this.deleteStoreInvoice(postData);
      if (result.status != 200)
        this.$toasted.show(
          result.data.friendlyMessage.message || "Hata Oluştu.",
          {
            duration: 3000,
            position: "top-right",
            type: "error",
          },
        );
      else {
        this.$toasted.show("Fatura Başarıyla Silindi.", {
          duration: 3000,
          position: "top-right",
          type: "success",
        });
        this.searchFilter();
      }

      this.deleteItem = null;
    },
    getInitialPeriod() {
      const now = new Date();
      const initialDate = new Date(now);
      initialDate.setMonth(now.getMonth() - 1);

      const year = initialDate.getFullYear();
      const month = String(initialDate.getMonth() + 1).padStart(2, "0");
      return `${year}-${month}`;
    },
  },
};
</script>

<style>
.v-data-footer__icons-before {
  display: none;
}

.v-data-footer__icons-after {
  display: none;
}
.address-area {
  max-width: 200px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.badge-active {
  background-color: #e6f7f0;
  color: #2e7d32;
}
.badge-passive {
  background-color: #fdecea;
  color: #c62828;
}
.input_custom input {
  padding: 21px 0;
}
.pdf-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #e3f2fd;
  color: #0d6efd;
  border-radius: 6px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}
.pdf-link i {
  color: #0d6efd !important;
}
.pdf-link:hover {
  background: #0d6efd;
  color: white;
  transform: scale(1.05);
}
.pdf-link:hover i {
  color: white !important;
}
.pdf-not-found {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f5f5f6;
  color: rgb(108, 117, 125);
  border-radius: 6px;
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  cursor: not-allowed;
}
</style>
